module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0134.jpg?v=5a642e1d";